var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostOfProductionGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9116_24076",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9116_24076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9116_24076",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9116_24076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6181 36.7261C23.1715 34.4528 23.6456 31.3284 26.624 28.5202C30.2832 25.092 35.7781 24.788 37.5895 24.788C37.9785 24.788 38.1852 24.788 38.1852 24.788C38.1852 24.788 38.5134 30.5504 35.2675 35.1214C33.4562 37.6743 30.9519 39.0116 28.7271 39.0116C28.1436 39.0116 27.5722 38.9265 27.0495 38.732C26.2958 38.5131 25.7244 38.1241 25.4934 37.8567C25.4934 37.8567 25.8581 37.1151 26.004 36.8355C26.5268 35.7414 27.1954 34.708 27.9126 33.7598C28.6785 32.7386 29.2985 32.0943 29.6754 31.7053C32.0703 29.1888 32.8119 29.1888 33.5534 28.5324C33.5899 28.4959 33.5656 28.4837 33.4926 28.4837C32.7997 28.4837 27.5844 30.0641 24.6181 36.7261ZM31.0248 18.4422C37.9663 18.4422 43.6071 24.0708 43.6071 31.0123C43.6071 37.9539 37.9785 43.5826 31.0248 43.5826C24.071 43.5826 18.4424 37.9539 18.4424 31.0123C18.4424 24.0708 24.071 18.4422 31.0248 18.4422ZM13.7863 52.919C12.0844 54.5845 9.19107 57.9641 14.4064 57.9641H47.6311C52.8463 57.9641 49.953 54.5724 48.2511 52.919C52.822 42.8531 50.6095 21.688 46.3303 10.8076C47.9471 9.17863 50.8648 6.0057 46.0385 5.25197C43.3518 4.83864 38.6715 4.07275 31.0126 4.07275C23.3538 4.07275 18.6734 4.83864 15.9867 5.25197C11.1605 6.0057 14.0781 9.17863 15.695 10.8076C11.4036 21.688 9.2032 42.8531 13.7742 52.919H13.7863Z",
    fill: "#01625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostOfProductionGreen);
export default __webpack_public_path__ + "static/media/cost_of_production_green.b4a1c0fc16f2f6d0b3023429a382afab.svg";
export { ForwardRef as ReactComponent };